// extracted by mini-css-extract-plugin
var _1 = "ListElement_list__bf83c";
var _2 = "ListElement_list-item__41a9a";
var _3 = "ListElement_list__items__1017d";
var _4 = "ListElement_text__b765e";
export { _1 as "list", _2 as "list-item", _3 as "list__items", _4 as "text" }
